function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { ChangeHighlighter, FormattedNumberInput, Loading } from '@rd-web-markets/shared/dist/util';
import { isValueDefined } from '@rd-web-markets/shared/dist/util/helpers/is_value_defined';
import offerInvoicesService from '../../services/offer_invoices.service';
import projectContractorsService from '@rd-web-markets/de/dist/services/project_contractor.service';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
const InvoiceForm = _ref => {
  let {
    financialYear,
    deleteOfferInvoice,
    offerInvoice,
    handleOfferInvoiceChange,
    setSelectedContractor,
    contractor,
    invoiceIndex,
    applicationSubmitted,
    setHasUnsavedChanges: setParentHasUnsavedChanges
  } = _ref;
  const {
    t
  } = useTranslation();
  const [savedStatus, setSavedStatus] = useState('');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const saveInvoiceChange = useErrorHandling(useCallback(async offerInvoice => {
    if (!offerInvoice.invoice_date) return;
    const updatedInvoice = await offerInvoicesService.update(financialYear.id, offerInvoice);
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    handleOfferInvoiceChange(updatedInvoice, invoiceIndex);
    setSavedStatus('saved');
    setHasUnsavedChanges(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  }, [contractor, financialYear, handleOfferInvoiceChange, invoiceIndex, setSelectedContractor, setParentHasUnsavedChanges]));
  const toggleIncludeInTotal = async e => {
    if (!offerInvoice.invoice_date) return;
    const updatedInvoice = await offerInvoicesService.update(financialYear.id, _objectSpread(_objectSpread({}, offerInvoice), {}, {
      include_in_total: e.target.checked
    }));
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    handleOfferInvoiceChange(updatedInvoice, invoiceIndex);
    setSavedStatus('saved');
    setHasUnsavedChanges(false);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  };
  const changeInvoice = (changedData, invoiceIndex) => {
    handleOfferInvoiceChange(changedData, invoiceIndex);
    setSavedStatus('not_saved');
    setHasUnsavedChanges(true);
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(true);
    }
  };
  if (!offerInvoice) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex pb-2"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      width: '180px'
    }
  }, "Invoice ", invoiceIndex + 1), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteButton, {
    variant: "danger",
    size: "sm",
    className: "text-white ms-3",
    disabled: applicationSubmitted,
    onClick: () => deleteOfferInvoice(offerInvoice.id)
  })), /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: e => changeInvoice(_objectSpread(_objectSpread({}, offerInvoice), {}, {
      [e.target.name]: e.target.value
    }), invoiceIndex),
    onBlur: () => saveInvoiceChange(offerInvoice),
    object: offerInvoice,
    name: "cost",
    type: "text",
    disabled: applicationSubmitted,
    size: "sm",
    className: "me-4 ms-2",
    style: {
      minWidth: '150px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: applicationSubmitted,
    selected: offerInvoice.invoice_date,
    onChange: date => {
      setHasUnsavedChanges(true);
      if (setParentHasUnsavedChanges) {
        setParentHasUnsavedChanges(true);
      }
      saveInvoiceChange(_objectSpread(_objectSpread({}, offerInvoice), {}, {
        invoice_date: date
      }));
    }
  }), /*#__PURE__*/React.createElement("p", {
    className: savedStatus !== 'saved' ? 'text-warning' : ''
  }, offerInvoice.invoice_date === null ? t('enter_date_to_save') : t(savedStatus))), /*#__PURE__*/React.createElement("div", {
    className: "mx-4"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: e => changeInvoice(_objectSpread(_objectSpread({}, offerInvoice), {}, {
      [e.target.name]: e.target.value
    }), invoiceIndex),
    onBlur: () => saveInvoiceChange(offerInvoice),
    object: offerInvoice,
    name: "comments",
    controlAs: "textarea",
    rows: "3",
    disabled: applicationSubmitted,
    style: {
      width: '280px',
      height: '100px'
    }
  })), /*#__PURE__*/React.createElement(Form.Check, {
    checked: offerInvoice.include_in_total && isValueDefined(offerInvoice.cost),
    value: !!offerInvoice.include_in_total,
    name: "include_in_total",
    onChange: toggleIncludeInTotal,
    disabled: !isValueDefined(offerInvoice.cost) || applicationSubmitted,
    label: t('include')
  })));
};
export default InvoiceForm;